import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteAllExchangeRates } from "@services/exchangeRate";
import { isFunction } from "lodash";

export const useDeleteAllExchangeRates = (options: Record<string, any> = {}) => {
  const queryClient = useQueryClient();

  return useMutation(deleteAllExchangeRates, {
    onSuccess: (res: any) => {
      queryClient.invalidateQueries({ queryKey: ["exchange_rates"] });

      if (isFunction(options.onSuccess)) {
        options.onSuccess(res);
      }
    },
    ...options,
  });
};
